export default "__VITE_ASSET__9eLHrOv2__"